import React from "react";

import type { Cell, RowData } from "@tanstack/react-table-v9";

import { columnLayout, pinEdges } from "./layout";
import type { TableV2Features } from "../../features";
import { getColumnAlign } from "../../formatters";
import type { TableV2Instance } from "../../hooks/useTableV2";
import { CellBox, CellText } from "../../styles";

const BodyCell = <TData extends RowData>({
  table,
  cell,
  fixedWidth = false,
}: {
  table: TableV2Instance<TData>;
  cell: Cell<TableV2Features, TData, unknown>;
  fixedWidth?: boolean;
}) => {
  const meta = cell.column.columnDef.meta;
  return (
    <CellBox
      role="cell"
      data-column-id={cell.column.id}
      $align={getColumnAlign(meta)}
      $pinned={cell.column.getIsPinned()}
      $overflow={meta?.overflow}
      $wrap={meta?.wrap}
      {...pinEdges(cell.column)}
      style={{
        ...columnLayout(cell.column, cell.column.getSize(), false, fixedWidth),
        ...meta?.style,
        ...meta?.getCellStyle?.(cell.getValue(), cell.row.original),
      }}
    >
      {meta?.overflow ? (
        <table.FlexRender cell={cell} />
      ) : (
        <CellText>
          <table.FlexRender cell={cell} />
        </CellText>
      )}
    </CellBox>
  );
};

export default BodyCell;
